<div
  class="maintenance-page h-100 d-flex align-items-center flex-column"
  [style.background-image]="'url(' + ('login-registrations/login-image.jpeg' | contentAssetImage) + ')'"
>
  <div class="container d-flex align-items-center flex-column">
    <div class="text-center maintenance-content d-flex flex-column">
      <img class="logo mb-4" draggable="false" [src]="'login-registrations/hawks-login-logo.png' | contentAssetImage" />
      <div class="text-white icon material-symbols-outlined mb-4">engineering</div>
      <h5 class="text-white mb-4">{{ 'maintenance.page.title' | translate }}</h5>
      <div
        class="text-white maintenance-text font-size-14 mb-4 text-center"
        [innerHTML]="'maintenance.page.details' | translate | markdownTranslate"
      ></div>
    </div>
  </div>
</div>
